(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mc-chai-rave"] && !Shopify.designMode) return;
  try {
    const mehfilEventSections = document.querySelectorAll('[data-mc-event-expiry]');
mehfilEventSections.forEach((eventSection) => {
  if (Date.now() >= Number(eventSection.dataset.mcEventExpiry) * 1000) {
    eventSection.remove();
    document.querySelectorAll('[data-mc-event-schema]').forEach((schema) => schema.remove());
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mc-events-carousel"] && !Shopify.designMode) return;
  try {
    function initializeMehfilEventCarousels() {
  document.querySelectorAll('[data-mch-carousel]').forEach((root) => {
    if (root.dataset.mchReady) return;
    root.dataset.mchReady = 'true';
    const track = root.querySelector('.mch-events-track');
    const controls = root.querySelector('.mch-events-controls');
    const previous = root.querySelector('[data-mch-previous]');
    const next = root.querySelector('[data-mch-next]');
    const status = root.querySelector('[data-mch-status]');
    let frame;
    let expiryTimer;
    const slides = () => [...track.querySelectorAll('.mch-events-slide')];
    const update = () => {
      frame = undefined;
      const cards = slides();
      if (!cards.length) { root.remove(); return; }
      const bounds = track.getBoundingClientRect();
      const rtl = getComputedStyle(track).direction === 'rtl';
      const first = cards[0].getBoundingClientRect();
      const last = cards[cards.length - 1].getBoundingClientRect();
      previous.disabled = rtl ? first.right <= bounds.right + 2 : first.left >= bounds.left - 2;
      next.disabled = rtl ? last.left >= bounds.left - 2 : last.right <= bounds.right + 2;
      controls.hidden = cards.length < 2 || (previous.disabled && next.disabled);
      const visible = cards.map((card, index) => ({ bounds: card.getBoundingClientRect(), index }))
        .filter((card) => Math.min(card.bounds.right, bounds.right) - Math.max(card.bounds.left, bounds.left) > card.bounds.width / 2);
      if (!visible.length) return;
      const start = visible[0].index + 1;
      const end = visible[visible.length - 1].index + 1;
      const label = status.dataset.statusTemplate.replace('__INDEX__', start === end ? String(start) : `${start}–${end}`).replace('__COUNT__', String(cards.length));
      if (status.textContent !== label) status.textContent = label;
    };
    const expire = () => {
      clearTimeout(expiryTimer);
      const now = Date.now();
      slides().forEach((slide) => {
        if (Number(slide.dataset.mchExpiry) * 1000 <= now) slide.remove();
      });
      if (!root.querySelector('#chai-rave')) root.querySelectorAll('[data-mc-event-schema]').forEach((schema) => schema.remove());
      update();
      const expiries = slides().map((slide) => Number(slide.dataset.mchExpiry) * 1000).filter((expiry) => expiry > now);
      if (expiries.length) expiryTimer = setTimeout(() => { if (root.isConnected) expire(); }, Math.min(Math.min(...expiries) - now + 1000, 2147483647));
    };
    const advance = (direction) => {
      const card = slides()[0];
      if (!card) return;
      const distance = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
      const rtl = getComputedStyle(track).direction === 'rtl';
      track.scrollBy({ left: distance * direction * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };
    previous.addEventListener('click', () => advance(-1));
    next.addEventListener('click', () => advance(1));
    track.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, { passive: true });
    root.mchUpdate = update;
    expire();
  });
}
initializeMehfilEventCarousels();
document.addEventListener('shopify:section:load', initializeMehfilEventCarousels);
window.addEventListener('resize', () => document.querySelectorAll('[data-mch-carousel]').forEach((root) => root.mchUpdate?.()));
  } catch(e) { console.error(e); }
})();

})();
